__turbopack_context__.v({
  "button": "m-text-intro-module-scss-module__dUVDTW__button",
  "chip": "m-text-intro-module-scss-module__dUVDTW__chip",
  "headline": "m-text-intro-module-scss-module__dUVDTW__headline",
  "placeholder": "m-text-intro-module-scss-module__dUVDTW__placeholder",
  "rich-text-headline": "m-text-intro-module-scss-module__dUVDTW__rich-text-headline",
  "text-intro-centered-desktop": "m-text-intro-module-scss-module__dUVDTW__text-intro-centered-desktop",
  "text-intro-centered-mobile": "m-text-intro-module-scss-module__dUVDTW__text-intro-centered-mobile",
  "text-o-stage-split": "m-text-intro-module-scss-module__dUVDTW__text-o-stage-split",
});
